import {
  DEFAULT_NA,
  PROFILE_SUBNAME,
} from '../newrelic-constants';

import {
  getEnvironmentMicro,
  getLastName,
  getLegEntity,
  getLegRegion,
  getOD,
  getPNR,
  getTripType,
} from '../newrelic-helpers';

export function nrBenefitscore(globalState, actionName, fullStory, metricData) {
  const data = {
    actionSubname: PROFILE_SUBNAME.WEBBENEFITSCORE,
    environment: getEnvironmentMicro(),
    errorCode: metricData?.action?.errorCode || '*',
    flow: 'MYB',
    fullstory: fullStory || DEFAULT_NA,
    hasCobrandBaggage: '*',
    hasFnfBaggage: '*',
    hasTierBaggage: '*',
    lastName: getLastName(globalState),
    legEntity: getLegEntity(globalState),
    legRegion: getLegRegion(globalState),
    reservationCode: getPNR(globalState),
    resultState: metricData?.resultState,
    route: getOD(globalState),
    storefront: metricData?.storefront,
    subflow: 'ancillary',
    totalBeneficiaries: '*',
    tripType: getTripType(globalState),
    url: window?.location?.href,
  };

  window.newrelic.addPageAction(actionName, data);
}
